<template>
  <CSidebar
    fixed
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  > <CSidebarBrand class="d-md-down-none" to="/">
      <template v-if="!minimize">
        <img :src="site.uri" style="max-width:140px;display:block;max-height:65px;"  class="pt-2 pb-2">
      </template>
        <template v-else>
        <img :src="smallLogo.uri" style="max-width:40px;display:block;max-height:65px;"  class="pt-2 pb-2">
      </template>
</CSidebarBrand>

<template v-if="navigation">
    <CRenderFunction flat :content-to-render="navigation" />
</template>
    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"
    />
  </CSidebar>
</template>

<script>
export default {
  name: 'TheSidebar',

  data() {
            return {
                sidebarBackground: 'vue',
                contenttypes: [],
                taxonomies: [],
                searchQuery: '',
                collapsed: false,
                unitType: "",
                openKeys: [],
                fieldData: {},
                searchResults:[],
                loading:true,
                roles: [],
                paths: [],
                navigation: false,
                site:'',
                smallLogo:'',
                ctypes: [],
                selectedKeys: []
            };
        },
  computed: {
    show () {
      return this.$store.state.sidebarShow
    },
    minimize () {
      return this.$store.state.sidebarMinimize
    }
  },
  mounted(){
    if (localStorage.user) {
        this.site = JSON.parse(localStorage.user).data.site_logo;
        this.smallLogo = JSON.parse(localStorage.user).data.site_logo_small;
    }
            this.selectedKeys = [this.$router.currentRoute.name];
            const loggedIn = localStorage.getItem('user');
            const user = JSON.parse(loggedIn);
            this.navigation = JSON.parse(localStorage.getItem('ctypes'));
            this.roles = user.data.type_id;
            this.paths = user.data.paths;
            this.unitType = user.data.unitType;
            this.ctypes = user.data.ctypes;
  }
}
</script>
